export enum TAB_KEYS {
  Timeline = "timeline",
  Debtor = "debtor",
  Collateral = "collateral",
}